import { Component, Input } from '@angular/core';
import CustomButtonConfig from './custom-button.config';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'custom-button',
  imports: [CommonModule],
  templateUrl: './custom-button.component.html',
  styleUrl: './custom-button.component.scss'
})
export class CustomButtonComponent {

  @Input() type?: string;
  @Input() title?: string;
  @Input() onClick?: () => void;

  @Input() config?: CustomButtonConfig;

}
